import { initFunnelbackListing } from "./searchFactory.js";
import loadFbjsScript from "../../_global/js/fbjsLoader.js";

/**
 * Registry defining all active article & content listing configurations
 */
export const LISTING_DEFINITIONS = [
    {
        name: "news-landing",
        selector: ".fbjs-search--news-landing",
        windowKey: "searchNewsLanding",
        placeholder: "News search",
        additionalParams: {
            "f.pageType|pageType": "News - Article",
            "f.pageType%7CpageType": "News - Press release",
        },
    },
    {
        name: "insights-listing",
        selector: ".fbjs-search--insights-listing",
        windowKey: "searchInsightsListing",
        placeholder: "Insights search",
        additionalParams: {
            gscope1: "insightsListing",
        },
        numRanks: 18,
    },
    {
        name: "articles",
        selector: ".fbjs-search--articles",
        windowKey: "searchArticles",
        placeholder: "Articles search",
        pageType: "insight - article",
    },
    {
        name: "blogs",
        selector: ".fbjs-search--blogs",
        windowKey: "searchBlogs",
        placeholder: "Blogs search",
        pageType: "insight - blog",
    },
    {
        name: "case-studies",
        selector: ".fbjs-search--case-study",
        windowKey: "searchCS",
        placeholder: "Case studies search",
        pageType: "expertise - case study",
        numRanks: 10000,
        loadMore: false,
    },
    {
        name: "podcasts",
        selector: ".fbjs-search--podcasts",
        windowKey: "searchPodcasts",
        placeholder: "Podcasts search",
        pageType: "insight - podcast",
        additionalParams: {
            nodup: "1",
        },
    },
    {
        name: "reports",
        selector: ".fbjs-search--reports",
        windowKey: "searchReports",
        placeholder: "Reports search",
        pageType: "insight - report",
    },
    {
        name: "viewpoints",
        selector: ".fbjs-search--viewpoints",
        windowKey: "searchViewpoints",
        placeholder: "Viewpoints search",
        pageType: "insight - viewpoint",
    },
    {
        name: "spotlights",
        selector: ".fbjs-search--spotlight",
        windowKey: "searchSpotlight",
        placeholder: "Spotlight search",
        pageType: "insight - spotlight",
        numRanks: 9,
    },
];

/**
 * Scan DOM and mount any active article listing instances
 */
export const initAllArticleListings = async () => {
    const hasActiveListing = LISTING_DEFINITIONS.some((def) =>
        document.querySelector(def.selector)
    );
    if (!hasActiveListing) return;

    try {
        await loadFbjsScript();
        LISTING_DEFINITIONS.forEach((def) => {
            if (document.querySelector(def.selector)) {
                initFunnelbackListing(def);
            }
        });
    } catch (err) {
        console.error("Failed to load Funnelback search client (fbjs):", err);
    }
};
